import { render } from "./InventoryPolicyModal.vue?vue&type=template&id=70608998&scoped=true"
import script from "./InventoryPolicyModal.vue?vue&type=script&lang=js"
export * from "./InventoryPolicyModal.vue?vue&type=script&lang=js"

import "./InventoryPolicyModal.vue?vue&type=style&index=0&id=70608998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70608998"]])

export default __exports__